module.exports = __webpack_public_path__ + "img/glasses-9-4.6af3166b.svg";